import { jsxs as p, jsx as s } from "react/jsx-runtime";
import { forwardRef as u, useId as m } from "react";
const k = u(function({ label: a, error: l, helperText: n, className: e, id: r, ...t }, d) {
  const o = m(), i = r ?? o, c = l ? `${i}-error` : n ? `${i}-helper` : void 0;
  return /* @__PURE__ */ p("div", { className: ["aiskills-input", e].filter(Boolean).join(" "), children: [
    a ? /* @__PURE__ */ s("label", { htmlFor: i, className: "aiskills-input__label", children: a }) : null,
    /* @__PURE__ */ s(
      "input",
      {
        id: i,
        ref: d,
        "aria-invalid": l ? !0 : void 0,
        "aria-describedby": c,
        className: "aiskills-input__control",
        ...t
      }
    ),
    l ? /* @__PURE__ */ s("span", { id: `${i}-error`, role: "alert", className: "aiskills-input__error", children: l }) : n ? /* @__PURE__ */ s("span", { id: `${i}-helper`, className: "aiskills-input__helper", children: n }) : null
  ] });
});
export {
  k as Input
};
//# sourceMappingURL=Input.js.map
